<div class="map-container">
  <div class="map-frame">
    <div id="map" #mapElement>
      <!-- <div (click)="closeMap()" class="close-btn">
          <span class="material-icons">close</span>
        </div> -->
    </div>
  </div>
</div>
